"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypographyStyling = void 0;
/*
 * Copyright (c) 2023 Discover Financial Services
 * Licensed under MIT License. See License.txt in the project root for license information
 */
const node_1 = require("../common/node");
const props_1 = require("../common/props");
/**
 * Typography styling properties used by multiple atoms.
 *
 * @category Atoms
 */
class TypographyStyling extends node_1.Node {
    constructor(name, parent, primaryFont, fontsSettings, defaultFontSize, defaultFontWeight, defaultLineHeight, defaultLetterSpacing) {
        super(name, parent);
        this.primaryFont = primaryFont;
        this.fontsSettings = fontsSettings;
        this.fontFamily = new props_1.PropertyStringSelectable("Font Family", false, this, {
            getSelectables: this.getFontFamilySelectables.bind(this),
            getDefaultValue: this.getFontFamilyDefaultSelectableValue.bind(this),
        });
        this.fontSize = new props_1.PropertyFontRange("Font Size", false, this, 0, 128, defaultFontSize);
        this.fontWeight = new props_1.PropertyNumberSelectable("Font Weight", false, this, [100, 300, 400, 500, 600, 700, 800, 900, 1000], defaultFontWeight);
        this.lineHeight = new props_1.PropertyPercentageSelectable("Line Height", false, this, [130, 160], defaultLineHeight);
        this.letterSpacing = new props_1.PropertyPixelRange("Character Spacing", false, this, -2, 10, defaultLetterSpacing);
    }
    getFontFamilySelectables() {
        const primary = this.getFontFamilySelectableValue(true);
        const secondary = this.getFontFamilySelectableValue(false);
        return [primary, secondary];
    }
    getFontFamilyDefaultSelectableValue() {
        return this.getFontFamilySelectableValue(this.primaryFont);
    }
    getFontFamilySelectableValue(getPrimary) {
        if (getPrimary) {
            return `${this.fontsSettings.primaryFont.getValue()}`;
        }
        else {
            return `${this.fontsSettings.secondaryFont.getValue()}`;
        }
    }
    getFontFamilyValue(getPrimary) {
        if (getPrimary) {
            return `${this.fontsSettings.primaryFont.getValue()}`;
        }
        else {
            return `${this.fontsSettings.secondaryFont.getValue()}`;
        }
    }
    deserialize(obj) {
        if (!obj)
            return;
        super.deserialize(obj);
        this.fontFamily.deserialize(obj.fontFamily);
        this.fontSize.deserialize(obj.fontSize);
        this.fontWeight.deserialize(obj.fontWeight);
        this.lineHeight.deserialize(obj.lineHeight);
        this.letterSpacing.deserialize(obj.letterSpacing);
    }
    serialize() {
        const obj = {};
        obj.fontFamily = this.fontFamily.serialize();
        obj.fontSize = this.fontSize.serialize();
        obj.fontWeight = this.fontWeight.serialize();
        obj.lineHeight = this.lineHeight.serialize();
        obj.letterSpacing = this.letterSpacing.serialize();
        return obj;
    }
}
exports.TypographyStyling = TypographyStyling;
